// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO : A DECOMMENTER POUR MISE EN PROD */
:root {
  --violet: #8554C5;
  --noir: #2e2e2e;
  --gris: #E7E7E7;
  --blanc: #FFFFFF;
  --ecriture: rgb(50, 50, 50);
  --bleu: rgb(101, 168, 255);
  --vert: #84DB8D;
  --fondCopieur: #FFFFFF;
  --valeurs: rgb(116, 115, 115);
  --rouge: #ED4F4F;
}

/* TODO : A SUPPRIMER POUR LA MISE EN PROD */
/* Dark mode - DEV MODE */
/* :root {
  --violet: #8554C5;
  --noir: #2e2e2e;
  --gris: #2e2e2e;
  --blanc: #FFFFFF;
  --ecriture: rgb(232, 232, 232);
  --bleu: rgb(101, 168, 255);
  --vert: #84DB8D;
  --fondCopieur:#454545;
  --valeurs: rgb(116, 115, 115);
  --rouge: #ED4F4F;
} */

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

html {
  background-color: var(--gris);
  font-family: 'Poppins', sans-serif;
}

@media screen and (min-width: 500px) {

  .CopieurList {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
    padding: 30px 30px;
  }
}

.PhraseContainer {
  /*display: none;*/
}

/*.PhraseContainer.active {*/
.PhraseContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*color: var(--gris);*/
  color: var(--noir);
  margin-top: 1rem;
  padding-top: 1rem;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-bottom: 1rem;
  /*border: 2px solid var(--rouge);*/
  border-radius: 5px;
  /*background-color: var(--rouge);*/
  background-color: #fff;
}

.PhraseDisconnect {
  color: var(--gris);
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-top: 1rem;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-bottom: 1rem;
  border: 2px solid var(--rouge);
  border-radius: 5px;
  background-color: var(--rouge);

}

.PhraseDisconnect a {
  color: #fff;
}


.fermerInfo {
  background-color: var(--violet);
  border: transparent;
  border-radius: 0.5rem;
  color: var(--gris);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: .5rem;
}

/*.PhraseContainer.detail {*/
.detail {
  display: block;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--noir);
  margin-top: 1rem;
  padding-top: 1rem;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-bottom: 1rem;
  border-radius: 5px;
  background-color: #ffffff;
  border: 2px solid #8554c5;
}


.PhraseContainer.histo {
  display: block;
  text-align: center;
  margin: 1rem;
}

.PhraseContainer.histo table {
  margin-left: 10%;
  width: 80%;
  border-collapse: collapse;
  margin-bottom: 1rem;
  ;
  background-color: #FFFFFF;
  color: #2e2e2e;
}

.PhraseContainer.histo table tr th {
  border: 1px solid var(--noir);
  padding: 1rem;
}

.PhraseContainer.histo table tbody tr td {
  border: 1px solid var(--noir);
}

@media screen and (max-width: 500px) {

  /*
.CopieurList {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 240vw;
  transform: rotate(90deg) translateY(-100vh);
  transform-origin: top left;
  

}

.CopieurContainer {
  width: 100vh;
  height: 100vw;
 transform: rotate(-90deg) translateX(-100vh);
  transform-origin: top left;
  overflow-x: hidden;
}

*/

  .CopieurList {
    display: flex;
    overflow-x: scroll;
    padding: 1rem 0;
    scroll-snap-type: x mandatory;
  }

  .CopieurItem {
    flex: 1 0 150px;
    margin-left: 1rem;
    scroll-snap-align: center;
    flex-basis: 200px;
  }

  ::-webkit-scrollbar-track {
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar {
    height: 6px;
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #3d4852;
    border-radius: 3px;
  }

  .Admin {
    flex-direction: column !important;
    margin-top: 5rem;
  }
}

.erreurCopieur {
  margin-bottom: .5rem;
}

/*message disconnect true */
.PhraseDisconnect {
  color: var(--gris);
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-top: 1rem;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-bottom: 1rem;
  border: 2px solid var(--rouge);
  border-radius: 5px;
  background-color: var(--rouge);
  /*display: none;*/

}

.errorNotification {
  border: 2px solid var(--violet);
  background-color: var(--violet);
}

.shownMessage {
  display: block,
}`, "",{"version":3,"sources":["webpack://./src/components/App.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C,yBAAyB;AACzB;;;;;;;;;;;GAWG;;AAEH;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;;EAEE;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;;AAEhC;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;;AAGA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,mBAAmB;;EAEnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE;;;;;;;;;;;;;;;;;;;;CAoBD;;EAEC;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;EAClB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;;AAEnB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE;AACF","sourcesContent":["/* TODO : A DECOMMENTER POUR MISE EN PROD */\n:root {\n  --violet: #8554C5;\n  --noir: #2e2e2e;\n  --gris: #E7E7E7;\n  --blanc: #FFFFFF;\n  --ecriture: rgb(50, 50, 50);\n  --bleu: rgb(101, 168, 255);\n  --vert: #84DB8D;\n  --fondCopieur: #FFFFFF;\n  --valeurs: rgb(116, 115, 115);\n  --rouge: #ED4F4F;\n}\n\n/* TODO : A SUPPRIMER POUR LA MISE EN PROD */\n/* Dark mode - DEV MODE */\n/* :root {\n  --violet: #8554C5;\n  --noir: #2e2e2e;\n  --gris: #2e2e2e;\n  --blanc: #FFFFFF;\n  --ecriture: rgb(232, 232, 232);\n  --bleu: rgb(101, 168, 255);\n  --vert: #84DB8D;\n  --fondCopieur:#454545;\n  --valeurs: rgb(116, 115, 115);\n  --rouge: #ED4F4F;\n} */\n\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\nhtml {\n  background-color: var(--gris);\n  font-family: 'Poppins', sans-serif;\n}\n\n@media screen and (min-width: 500px) {\n\n  .CopieurList {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    flex-wrap: wrap;\n    padding: 30px 30px;\n  }\n}\n\n.PhraseContainer {\n  /*display: none;*/\n}\n\n/*.PhraseContainer.active {*/\n.PhraseContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /*color: var(--gris);*/\n  color: var(--noir);\n  margin-top: 1rem;\n  padding-top: 1rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  padding-bottom: 1rem;\n  /*border: 2px solid var(--rouge);*/\n  border-radius: 5px;\n  /*background-color: var(--rouge);*/\n  background-color: #fff;\n}\n\n.PhraseDisconnect {\n  color: var(--gris);\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding-top: 1rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  padding-bottom: 1rem;\n  border: 2px solid var(--rouge);\n  border-radius: 5px;\n  background-color: var(--rouge);\n\n}\n\n.PhraseDisconnect a {\n  color: #fff;\n}\n\n\n.fermerInfo {\n  background-color: var(--violet);\n  border: transparent;\n  border-radius: 0.5rem;\n  color: var(--gris);\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  font-size: 0.9rem;\n  cursor: pointer;\n  margin-top: .5rem;\n}\n\n/*.PhraseContainer.detail {*/\n.detail {\n  display: block;\n  text-align: center;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: var(--noir);\n  margin-top: 1rem;\n  padding-top: 1rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  padding-bottom: 1rem;\n  border-radius: 5px;\n  background-color: #ffffff;\n  border: 2px solid #8554c5;\n}\n\n\n.PhraseContainer.histo {\n  display: block;\n  text-align: center;\n  margin: 1rem;\n}\n\n.PhraseContainer.histo table {\n  margin-left: 10%;\n  width: 80%;\n  border-collapse: collapse;\n  margin-bottom: 1rem;\n  ;\n  background-color: #FFFFFF;\n  color: #2e2e2e;\n}\n\n.PhraseContainer.histo table tr th {\n  border: 1px solid var(--noir);\n  padding: 1rem;\n}\n\n.PhraseContainer.histo table tbody tr td {\n  border: 1px solid var(--noir);\n}\n\n@media screen and (max-width: 500px) {\n\n  /*\n.CopieurList {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  width: 240vw;\n  transform: rotate(90deg) translateY(-100vh);\n  transform-origin: top left;\n  \n\n}\n\n.CopieurContainer {\n  width: 100vh;\n  height: 100vw;\n transform: rotate(-90deg) translateX(-100vh);\n  transform-origin: top left;\n  overflow-x: hidden;\n}\n\n*/\n\n  .CopieurList {\n    display: flex;\n    overflow-x: scroll;\n    padding: 1rem 0;\n    scroll-snap-type: x mandatory;\n  }\n\n  .CopieurItem {\n    flex: 1 0 150px;\n    margin-left: 1rem;\n    scroll-snap-align: center;\n    flex-basis: 200px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background-color: #F5F5F5;\n  }\n\n  ::-webkit-scrollbar {\n    height: 6px;\n    background-color: #F5F5F5;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: #3d4852;\n    border-radius: 3px;\n  }\n\n  .Admin {\n    flex-direction: column !important;\n    margin-top: 5rem;\n  }\n}\n\n.erreurCopieur {\n  margin-bottom: .5rem;\n}\n\n/*message disconnect true */\n.PhraseDisconnect {\n  color: var(--gris);\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding-top: 1rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  padding-bottom: 1rem;\n  border: 2px solid var(--rouge);\n  border-radius: 5px;\n  background-color: var(--rouge);\n  /*display: none;*/\n\n}\n\n.errorNotification {\n  border: 2px solid var(--violet);\n  background-color: var(--violet);\n}\n\n.shownMessage {\n  display: block,\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
